import { Content } from './simple-select.styled';

export const SimpleSelect = (props) => {
  const { children, name, width, ...rest } = props;
  const nameOk = name ?? 'noname';
  const other = {};
  if (width) {
    other.style = { width };
  }

  return (
    <Content {...rest} {...other} name={nameOk}>
      {children}
    </Content>
  );
};
